define.alias("shared/components/shared/post/secondary/caption-writer/footer", "settings/components/shared/post/secondary/caption-writer/footer");